import { render } from "./HomepagePopup.vue?vue&type=template&id=31b94145&scoped=true"
import script from "./HomepagePopup.vue?vue&type=script&lang=js"
export * from "./HomepagePopup.vue?vue&type=script&lang=js"

import "./HomepagePopup.vue?vue&type=style&index=0&id=31b94145&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b94145"]])

export default __exports__